var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClubs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.059,
    height: 18.758,
    viewBox: "0 0 12.059 18.758",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_12058201721595759714",
    "data-name": 12058201721595760000,
    transform: "translate(-7 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9840",
    "data-name": "Group 9840",
    transform: "translate(7.03 13.419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1934",
    "data-name": "Path 1934",
    d: "M13.044,22.365a9,9,0,0,1-5.761-2.144.665.665,0,1,1,.871-1,7.311,7.311,0,0,0,4.89,1.876,7.439,7.439,0,0,0,4.89-1.876.665.665,0,1,1,.871,1A9,9,0,0,1,13.044,22.365Z",
    transform: "translate(-7.045 -19.045)",
    fill: "#db5f28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9841",
    "data-name": "Group 9841",
    transform: "translate(12.359 15.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1935",
    "data-name": "Path 1935",
    d: "M15.67,27.359a.633.633,0,0,1-.67-.67V22.67a.67.67,0,0,1,1.34,0v4.02A.633.633,0,0,1,15.67,27.359Z",
    transform: "translate(-15 -22)",
    fill: "#db5f28"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1936",
    "data-name": "Path 1936",
    d: "M13.029,2a6.029,6.029,0,1,0,6.029,6.029A6,6,0,0,0,13.029,2ZM10.618,9.3a.4.4,0,0,1-.268.067A.663.663,0,0,1,9.881,8.23a.935.935,0,0,1,.6-.2c.067,0,.067,0,.134.067.067,0,.067,0,.134.067.067,0,.067.067.134.067a.724.724,0,0,1,.2.469.608.608,0,0,1-.2.469C10.752,9.235,10.685,9.3,10.618,9.3Zm1.541,1.876c-.067.067-.134.134-.2.134s-.2.067-.268.067a.663.663,0,0,1-.469-1.139.935.935,0,0,1,.6-.2c.067,0,.067,0,.134.067.067,0,.067,0,.134.067.067,0,.067.067.134.067a.724.724,0,0,1,.2.469A1.08,1.08,0,0,1,12.158,11.178ZM13.3,9.3a.4.4,0,0,1-.268.067A.663.663,0,0,1,12.56,8.23a.935.935,0,0,1,.6-.2c.067,0,.067,0,.134.067.067,0,.067,0,.134.067.067,0,.067.067.134.067a.724.724,0,0,1,.2.469.608.608,0,0,1-.2.469C13.431,9.235,13.364,9.3,13.3,9.3Zm1.541,1.876c-.067.067-.134.134-.2.134s-.2.067-.268.067A.663.663,0,0,1,13.9,10.24a.935.935,0,0,1,.6-.2c.067,0,.067,0,.134.067.067,0,.067,0,.134.067.067,0,.067.067.134.067a.724.724,0,0,1,.2.469A1.08,1.08,0,0,1,14.838,11.178Zm1.34-2.01c-.067.067-.134.134-.2.134s-.2.067-.268.067A.663.663,0,0,1,15.24,8.23a.935.935,0,0,1,.6-.2c.067,0,.067,0,.134.067.067,0,.067,0,.134.067.067,0,.067.067.134.067a.724.724,0,0,1,.2.469A1.08,1.08,0,0,1,16.178,9.168Z",
    fill: "#0077b6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClubs);
export default __webpack_public_path__ + "static/media/clubs.4ebe15802de4d68e837bbed791689b6a.svg";
export { ForwardRef as ReactComponent };